// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import TextInput from './TextInput'

class PriceRangeFields extends Component {
  render() {
    const {
      currentMinPrice,
      currentMaxPrice,
      handleMinPriceChange,
      handleMaxPriceChange,
      handleInputChange,
    } = this.props;
    
    return ( 
      <div className="price-range__fields">
        <TextInput
          labelTitle="Menor preço"
          name="min_price"
          placeholderText="Menor preço"
          preLabelText="R$"
          value={currentMinPrice}
          handleChange={handleMinPriceChange}
          handleInputChange={handleInputChange}
        />
        <TextInput
          labelTitle="Maior preço"
          name="max_price"
          placeholderText="Maior preço"
          preLabelText="R$"
          value={currentMaxPrice}
          handleChange={handleMaxPriceChange}
          handleInputChange={handleInputChange}
        />
      </div>
    );
  }
}

PriceRangeFields.defaultProps = {
  handleMinPriceChange: () => {},
  handleMaxPriceChange: () => {},
  handleInputChange: () => {},
  currentMinPrice: null,
  currentMaxPrice: null,
};

PriceRangeFields.propTypes = {
  handleMinPriceChange: PropTypes.func,
  handleMaxPriceChange: PropTypes.func,
  handleInputChange: PropTypes.func,
  currentMinPrice: PropTypes.number,
  currentMaxPrice: PropTypes.number,
};

export default PriceRangeFields;
